import { render } from "./DocumentClassFieldTable.vue?vue&type=template&id=46a0d7be&scoped=true&ts=true"
import script from "./DocumentClassFieldTable.vue?vue&type=script&lang=ts"
export * from "./DocumentClassFieldTable.vue?vue&type=script&lang=ts"

import "./DocumentClassFieldTable.vue?vue&type=style&index=0&id=46a0d7be&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46a0d7be"]])

export default __exports__